import React from 'react';
import Button from 'devextreme-react/button';

import { orderBy } from 'lodash';

import CoreUtils from '../utils/CoreUtils';
import StringUtils from '../utils/StringUtils';

import DataItemView from '../view/DataItemView';

export default class TileView extends DataItemView {
  static displayName = TileView.name;

  constructor(props) {
    super(props);

    this.bindDataItem(props.itemsSource);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.itemsSource);
  }

  render() {
    if (!this.state.isDataBound)
      return (<div />);

    var dataObjects = this.state.dataObjects;
    if (StringUtils.isNonEmptyString(this.props.sortField))
      dataObjects = orderBy(dataObjects, [this.props.sortField], ['asc'])

    return (
      <div className="pwx-tile-container">
        <div className="pwx-tile-header">
          <div className="pwx-tile-title" hidden={!StringUtils.isNonEmptyString(this.props.title)}>
            {this.props.title}
          </div>
          <div className="pwx-tile-button-bar">
            <Button type="normal" icon="add" onClick={this.onCreateButtonClicked.bind(this)} />
            <span className="pwx-button-spacer" />
              <Button type="normal" icon="minus" disabled={!this.isSelectedItemValid()} onClick={this.onRemoveButtonClicked.bind(this)} />
          </div>
        </div>
        <div className="pwx-tile-content">
          {
            dataObjects.map((dataObject, index) => {
              return (
                <div key={dataObject[this.props.keyExpr]}>
                  <div className={index > 0 ? this.props.spacerStyle : ""} />
                  <div className={this.getElementClassName(dataObject)} onMouseDown={this.onMouseDown.bind(this, dataObject)}>
                    {this.props.renderTile(dataObject)}
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }

  getElementClassName(item) {
    var style = this.props.tileStyle;

    if (CoreUtils.isDefinedAndNotNull(this.props.selectedItem) && item === this.props.selectedItem)
      style += (' ' + this.props.selectedTileStyle)

    return style;
  }

  onCreateButtonClicked() {
    var selectedItem = this.isSelectedItemValid()
      ? this.props.selectedItem
      : null;

    var newSelectedItem = this.dataItem.insertNewDataObject(selectedItem);
    this.selectItem(newSelectedItem);
  }

  onRemoveButtonClicked() {
    if (!this.isSelectedItemValid())
      return;

    if (this.props.selectedItem.isNew)
      this.dataItem.removeDataObject(this.props.selectedItem);
    else
      this.props.selectedItem.setIsDeleted(true);

    this.selectDefaultItem();
  }

  onMouseDown(item, event) {
    this.selectItem(item);
  }

  isSelectedItemValid() {
    if (this.dataItem === null)
      return false;

    return CoreUtils.isDefinedAndNotNull(this.props.selectedItem)
      && this.dataItem.indexOf(this.props.selectedItem) !== -1;
  }

  selectDefaultItem() {
    if (this.isSelectedItemValid())
      return;

    var defaultItem = this.dataItem.length > 0
      ? this.dataItem.getAt(0)
      : null;

    this.selectItem(defaultItem);
  }

  selectItem(item) {
    if (this.dataItem === null)
      return;

    if (CoreUtils.isDefinedAndNotNull(this.props.selectedItem) && item === this.props.selectedItem)
      return;

    if (CoreUtils.isDefinedAndNotNull(this.props.onSelectionChanged))
      this.props.onSelectionChanged(item);
  }
}